export default __webpack_public_path__ + "static/aadhitya-amarendiran-layer5-maintainer-3816a942afddde522fbc9b0f3939d582.png";